import { CloudFile } from 'owa-attachment-file-types';
import {
    CreateSharingLinkFromFileProviderResult,
    GetSharingInfoResponseBase,
} from 'owa-fileprovider-link-services';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { createGetBoxSharingInfoResponse } from './createGetBoxSharingInfoResponse';
import { createGetDropboxSharingInfoResponse } from './createGetDropboxSharingInfoResponse';
import { createGetGDriveSharingInfoResponse } from './createGetGDriveSharingInfoResponse';
import { createGetODCSharingInfoResponse } from './createGetODCSharingInfoResponse';

export function createGetSharingInfoResponse(
    file: CloudFile,
    createLinkResult: CreateSharingLinkFromFileProviderResult
): GetSharingInfoResponseBase {
    switch (file.providerType) {
        case AttachmentDataProviderType.OneDriveConsumer:
            return createGetODCSharingInfoResponse(file, createLinkResult);
        case AttachmentDataProviderType.Dropbox:
            return createGetDropboxSharingInfoResponse(file, createLinkResult);
        case AttachmentDataProviderType.Box:
            return createGetBoxSharingInfoResponse(file, createLinkResult);
        case AttachmentDataProviderType.GDrive:
            return createGetGDriveSharingInfoResponse(file, createLinkResult);
        default:
            throw new Error(`createGetSharingInfoResponse does not support ${file.providerType}`);
    }
}
